<template>
  <div>
    <vxe-grid ref="xTable" v-bind="gridOptions" :data="tableData"></vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gridOptions: {
        size: 'mini',
        border: 'inner',
        columns: [
          { field: 'driverNo', title: '温度计编号', width: 150 },
          { field: 'startTime', title: '开始时间' },
          {
            field: 'endTime',
            title: '结束时间',
            editRender: {
              name: 'date-picker',
              props: {
                type: 'datetime',
                valueFormat: 'yyyy-MM-dd HH:mm:ss'
              }
            }
          }
        ],
        editConfig: { trigger: 'click', mode: 'row', showStatus: true },
        editRules: {
          endTime: [
            {
              required: true,
              message: '请选择温度计结束时间'
            }
          ]
        }
      },
      tableData: this.data
    }
  },
  methods: {
    validate() {
      return this.$refs.xTable.validate(true).catch((error) => {
        const { row, column } = error
        this.$refs.xTable.setActiveCell(row, column)
        return error
      })
    }
  }
}
</script>
